import { http } from '@/utils'
import type { ReqUploadPre, ResPreUploadResult } from '@/types/apiTypes'
import type {
  ResGetSystemConfig,
  ResCommon,
  ResGetBannerList,
  ResGetHomeMv,
} from '@/api/type/result'
import type { ResGetHomeMvItem } from '@/api/type/other'
import type { ReqGetSigned, ReqGetBanner } from '@/api/type/params'
export const commonApi = {
  // 文件上传

  postUploadApi: (data: ReqUploadPre) => {
    return http.post<ReqUploadPre, ResPreUploadResult>(`oss/pre`, {
      data,
    })
  },
  //获取下载
  getSigned: (data: ReqGetSigned) => {
    return http.post<ReqGetSigned, ResCommon>('oss/signed/url', {
      data,
    })
  },
  //获取banner
  getBanner: (params: ReqGetBanner) => {
    return http.get<ReqGetBanner, ResGetBannerList>('banner', {
      params,
    })
  },
  //获取系统配置
  getSystemConfig: () => {
    return http.get<any, ResGetSystemConfig>('system_config/common_config')
  },
  //获取首页MV
  getHomeMv: () => {
    return http.get<any, ResGetHomeMv>('admin/system-config/mv_banner')
  },
  //修改首页MV
  updateHomeMv: (data: { items: ResGetHomeMvItem[] }) => {
    return http.post<{ items: ResGetHomeMvItem[] }, ResCommon>('admin/system-config/mv_banner', {
      data,
    })
  },
}
